import React from 'react';
import MainSidebar from './MainSidebar';
import { FiShoppingCart, FiTag } from 'react-icons/fi';

export default function PurchaseSidebar() {
  const menuItems = [
    {
      id: 'purchase_orders',
      title: 'Purchase Orders',
      links: [
        { path: '/purchase/orders', label: 'List', icon: FiShoppingCart }
      ]
    },
    {
      id: 'supplier_invoices',
      title: 'Supplier Invoices',
      links: [
        { path: '/purchase/records', label: 'List', icon: FiTag }
      ]
    }
  ];
  
  return <MainSidebar moduleName="Purchases" menuItems={menuItems} />;
}